<template>
  <v-app>
    <v-card app>
      <v-card-text class="py-2">
        <v-row align="center" dense>
          <v-col><router-link to="/"><v-img :src="require('@/assets/Logo/logo5.svg')" width="110"></v-img></router-link></v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn v-if="loggedin" color="#bf9507" small elevation="0" class="mr-2 px-2" style="text-transform: none" to="/points"><v-icon small>mdi-plus-circle</v-icon><span class="ml-1" style="color:white;">{{points}} pt</span></v-btn>
            <!--<v-btn v-if="loggedin" color="#0086D2" small elevation="0" class="mr-1 px-2" style="text-transform: none"><span style="color:white;">{{ap}} ap</span></v-btn>-->
            <v-btn v-if="loggedin" icon to="/mycards">
              <v-badge :content="`${cards.filter(card=>card.order_status==0).length}`" :value="badgeValue" color="#bf9507" overlap bottom offset-x="12" offset-y="12">
                <v-icon color="black">mdi-cards-outline</v-icon>
              </v-badge>
            </v-btn>
            <v-btn v-if="loggedin" icon to="/profile"><v-icon color="black">mdi-account-circle</v-icon></v-btn>
            <v-btn v-if="!loggedin" text to="/signup">新規登録</v-btn>
            <v-btn v-if="!loggedin" text to="/login">ログイン</v-btn>
          </v-col>
        </v-row>
        
        <v-row align="center" class="mt-0" dense>
          <v-col style="background-color:#004B78;border-radius:5px;">
            <div class="movetext">
              <ul>
                <li v-for="msg in msgs" class="white--text">{{msg}}</li>
              </ul>
            </div>
          </v-col>
          <!-- <v-col v-if="loggedin" class="pt-0 px-0">
            <div style="position:relative;">
              <p class="mb-0 text-left mosaic" style="font-size:10px;">{{xp}} EXP</p>
              <v-progress-linear class="mosaic" height="10" rounded background-color="black" color="#0086D2" value="15"></v-progress-linear>
              <div style="position:absolute;top:50%;left:50%;transform: translate(-50%, -50%); z-index: 1;">
                <p class="rocknFont mb-0" style="font-size: 12px;">Coming Soon</p>
              </div>
            </div>
          </v-col> -->
        </v-row>
      </v-card-text>
      <v-card-text v-if="devShow=='true'" class="orange white--text text-center py-1">開発環境</v-card-text>
    </v-card>
    
    <v-main class="main noisy-back mh">
      <router-view/>
    </v-main>
    
    <v-snackbar v-model="$store.state.snackbar">
      {{ $store.state.snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="closeSnackbar">Close</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import store from './store'
import liff from '@line/liff'
import Api from '@/modules/api'
import Utils from '@/modules/utils'

export default {
  name: 'App',
  data(){
    return {
      devShow:process.env.VUE_APP_DEV_SHOW,
      msgs: [
        '✨ TwitterでポケカBOXプレゼント企画開催中!! ✨'
      ]
    }
  },
  computed: {
    loggedin: function(){
      const user = store.getters.user
      if(user == null){
        return false
      }else{
        return true
      }
    },
    points: function(){
      const userData = store.getters.userData
      if(userData == null){
        return null
      }else{
        // if(userData["points"]>=10000) return Math.floor(userData["points"]/1000)+'k'
        return userData["points"]
      }
    },
    ap: function(){
      const userData = store.getters.userData
      if(userData == null){
        return null
      }else{
        if(userData["ap"]>=10000) return Math.floor(userData["ap"]/1000)+'k'
        return userData["ap"]
      }
    },
    xp: function(){
      const userData = store.getters.userData
      if(userData == null){
        return null
      }else{
        if(userData["xp"]>=10000) return Math.floor(userData["xp"]/1000)+'k'
        return userData["xp"]
      }
    },
    cards: function(){
      if(store.getters.myCards == null) return []
      return store.getters.myCards
    },
    badgeValue: function(){
      return this.cards.filter(card=>card.order_status==0).length
    }
  },
  created: function(){
    Utils.getSession().catch(err => {
      console.log(err)
    })
  },
  methods: {
    ...mapActions(["openSnackbar", "closeSnackbar"]),
  },
};
</script>

<style scoped>
@import url(https://fonts.googleapis.com/earlyaccess/notosansjp.css);

#app {
  font-family: 'Noto Sans JP', sans-serif;
}

.bg {
  /*background-color:rgb(239,224,181);*/
  /*background-color:rgb(181,225,239);*/
  /*background-image:url("@/assets/img/back_seamless_trans.png");*/
  /*background-image:url("@/assets/img/bubble.svg");*/
  /*background-image:url("@/assets/img/monster_ball_back.png");*/
  /*background-repeat:repeat;*/
  /*filter: blur(1px);*/
}
.main {
  position:relative;
}
.blob1 {
  position:absolute;
  top:20%;
  /*left:500px;*/
  right:-15%;
  filter: blur(10px);
}
.blob2 {
  position:absolute;
  left:-15%;
  filter: blur(10px);
}
.blob3 {
  position:absolute;
  top:60%;
  left:40%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  filter: blur(10px);
}
.blob4 {
  position:absolute;
  top:10%;
  left:60%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  filter: blur(10px);
}
.blob5 {
  position:absolute;
  top:80%;
  right:10%;
  filter: blur(10px);
}

.movetext{
  /*margin : 0 auto 40px;*/
  /*width : 100%;*/
  text-align : center;
  overflow : hidden;
}
.movetext ul{
  margin:0;
  display : inline-block;
  padding-left: 100%;
  white-space : nowrap;
  line-height : 1em;
  animation : scrollMoveText 15s linear infinite;
}
.movetext ul li{
  display:inline;
  margin:0 100px 0 0;
}

@keyframes scrollMoveText{
  0% { transform: translateX(0)}
  100% { transform: translateX(-100%)}
}

.noisy-back {
  background-color:#004B78;
  background-image: url(data:image/png;base64,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);  
  background-repeat: repeat;
} 
.mh {
  min-height: 80vh;
}
.mosaic {
  filter: blur(1.5px);
}
.rocknFont {
  color:white;
  font-weight: bold;
  font-family: 'RocknRoll One', sans-serif;
  text-shadow: 2px  2px 3px black,-2px  2px 3px black,2px -2px 3px black,-2px -2px 3px black;
}
</style>